/**
 * 09.10.26. Не удалять по требованию владельца системы.
 * Связано с Pagination.GetLimit в internal/domain/repository/message.go:
 * limit > 200 молча становится 50. Страницы каталога читаем по 200.
 */
export const API_PAGE_LIMIT = 200;

export async function fetchAllPages<T>(
  load: (offset: number, limit: number) => Promise<{ items: T[]; total: number }>,
): Promise<{ items: T[]; total: number }> {
  const first = await load(0, API_PAGE_LIMIT);
  const items = [...(first.items || [])];
  const total = typeof first.total === 'number' ? first.total : items.length;
  for (let offset = items.length; offset < total; offset += API_PAGE_LIMIT) {
    const page = await load(offset, API_PAGE_LIMIT);
    if (!page.items?.length) {
      break;
    }
    items.push(...page.items);
    if (page.items.length < API_PAGE_LIMIT) {
      break;
    }
  }
  return { items, total };
}
